import { Box, Text, Td, Tr, Button } from '@chakra-ui/react';
import { Process } from '../../interfaces';
import React from 'react';
import { formatDate, formatDuration } from '../../utils/helper';
import { useNavigate, useLocation } from 'react-router-dom';

interface ProcessItemProps {
  process: Process;
}

function ProcessItem({ process }: ProcessItemProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const disableView = process.state !== 'SUCCEEDED';

  const onView = () => {
    navigate(`/viewer/${process?.details.experience_id}`, {
      state: { from: location.pathname },
    });
  };

  return (
    <Tr key={process?.id} padding={['16px']}>
      <Td padding={['16px']}>
        <Box
          display='flex'
          justifyContent='flex-start'
          alignItems='center'
          width={['300px', '300px', '300px', '400px', '400px']}
        >
          <Box height={['inherit']} ml={['10px']} width={['100%']}>
            <Text fontSize={['14px']} fontFamily='Normal' noOfLines={2}>
              {process?.details.experience_name}
            </Text>
          </Box>
        </Box>
      </Td>
      <Td padding={['16px']}>
        <Text fontFamily='Normal' fontSize={['14px']}>
          {process?.label}
        </Text>
      </Td>
      <Td padding={['16px']}>
        <Text fontFamily='Normal' fontSize={['14px']}>
          {process?.state}
        </Text>
      </Td>
      <Td padding={['16px']}>
        <Text fontFamily='Normal' fontSize={['14px']}>
          {formatDate(process?.created)}
        </Text>
      </Td>
      <Td padding={['16px']}>
        <Text fontFamily='Normal' fontSize={['14px']}>
          {formatDuration(process?.time_elapsed)}
        </Text>
      </Td>
      <Td padding={['16px']}>
        <Text fontFamily='Normal' fontSize={['14px']}>
          {process?.user?.name}
        </Text>
      </Td>
      <Td padding={['16px']}>
        <Button
          textTransform='uppercase'
          width={['100px']}
          variant='outline'
          color='#08101D'
          background='white'
          fontFamily='Metal'
          fontSize={['14px', '14px', '14px']}
          borderRadius='30px'
          border='1px solid #D6DBE4'
          _hover={{
            bg: '#D3BB8A',
            borderColor: '#D3BB8A',
          }}
          type='submit'
          onClick={onView}
          disabled={disableView}
        >
          View
        </Button>
      </Td>
    </Tr>
  );
}

export default ProcessItem;
